<template>
  <div>
    <p class="font-bold text-15 text-center mt-20 text-app-color">Or invite with a link</p>

    <div
      class="flex items-center justify-center text-brand hover:text-brand-hover anim-color cursor-pointer"
      :class="fontSize"
      @click="copyLink"
    >
      <p>{{ inviteLink }}</p>
      <div class="relative ml-10">
        <div v-if="copied" class="text-app-color absolute -top-40 left-1/2 transform -translate-x-1/2 bg-white shadow-user-badge py-5 px-10 text-13 rounded-8">
          Copied!
        </div>
        <svg class="stroke-current w-27 h-27" width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="22.5" cy="22.5" r="21.6" fill="#FAFAFA" stroke="null" stroke-width="1.8" />
          <path d="M26.3416 31.8293H15.366V17.561C15.366 16.9574 14.8721 16.4635 14.2685 16.4635C13.6648 16.4635 13.1709 16.9574 13.1709 17.561V31.8293C13.1709 33.0367 14.1587 34.0245 15.366 34.0245H26.3416C26.9453 34.0245 27.4392 33.5306 27.4392 32.9269C27.4392 32.3232 26.9453 31.8293 26.3416 31.8293ZM31.8294 27.4391V14.2684C31.8294 13.061 30.8416 12.0732 29.6343 12.0732H19.7563C18.5489 12.0732 17.5611 13.061 17.5611 14.2684V27.4391C17.5611 28.6464 18.5489 29.6342 19.7563 29.6342H29.6343C30.8416 29.6342 31.8294 28.6464 31.8294 27.4391ZM29.6343 27.4391H19.7563V14.2684H29.6343V27.4391Z" fill="#3F40F2" />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, ref } from 'vue'

export default defineComponent({

  props: {
    link: String,
    fontSize: { type: String, default: 'text-15' }
  },

  setup (props) {
    const copied = ref(false)

    const inviteLink = computed(() => `helloivy.co/team/${props.link}`)

    function copyLink () {
      const el = document.createElement('input')
      el.value = inviteLink.value
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)

      copied.value = true

      setTimeout(() => (copied.value = false), 3000)
    }

    return {
      // ref
      // data
      copied,
      // computed
      inviteLink,
      // function
      copyLink
    }
  }
})
</script>
